// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_rrh","cls2":"common-cls2_rKy common-cls1_rrh","gray":"common-gray_Tl8"};